import PropTypes from "prop-types"
import React from "react"

import typeMatch from "./typeMatch"

const CruiseStopIcon = ({ stopType }) => {
  const iconClassNames = (stopType) => {
    return typeMatch(stopType, {
      reservation: () => "icon icon-calendar-check-o text-lg text-teal-600",
      marina: () => "icon icon-ship-store text-lg text-orange-600",
      location: () => "icon icon-md-location-on text-lg text-blue-600",
      note: () => "icon icon-document text-lg text-gray-600",
    })
  }

  return (
    <div className={`inline-flex items-center justify-center rounded-full`}>
      <i className={iconClassNames(stopType)} />
    </div>
  )
}

CruiseStopIcon.propTypes = {
  stopType: PropTypes.string.isRequired,
}

export default CruiseStopIcon
